export enum SurveyJSInputTypes {
    DATE = 'date',
    NUMBER = 'number',
}
